var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$isAuRegion())?_c('div',[_c('AuTreatmentHistory')],1):(this.$isUSRegion())?_c('div',[_c('UsTreatmentHistory')],1):_c('div',[_c('NZTreatmentHistory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }